
import React,{useState} from 'react'
import '../Assets/Additionalcss/Login.css';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { BASE_URL } from '../Config/Base';
import {FadeLoader} from 'react-spinners';

export default function Form() {


  const [name,setName]= useState([])

  let Slash="/"
  let Hashslash="/#/"
 function ActivityIndicator(){

  document.getElementById("activity-indicator").style.display = "block";
 
 
 }
  
  const handleSubmit=()=>{
    let data = {
          email: document.getElementById('email').value,
    
          password: document.getElementById('password').value,
        }
    
 
  var email = document.getElementById("email").value;
   var psw = document.getElementById("password").value;

   if(!email ){
    document.getElementById("errmsg").innerHTML = "Enter Email Id";
    document.getElementById("errmsg1").innerHTML = "";
    
     }
     else if(!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(document.getElementById("email").value)){
      document.getElementById("errmsg").innerHTML = "";
       document.getElementById("errmsg1").innerHTML = "Invalid Email Address";
      
     }
     else {
    
       document.getElementById("errmsg1").innerHTML = "";
     }
  if(!psw){
    document.getElementById("errmsg2").innerHTML = "Enter Password";
    document.getElementById("errmsg3").innerHTML = "";

  }
  else if(!/^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/.test(psw)){
    //  document.getElementById("msg1").innerHTML = "Password must contain 8 character, atleast one UPPERCASE, one lowercase, one number & one special char";
    document.getElementById("errmsg2").innerHTML = "";
    document.getElementById("errmsg3").innerHTML = "Invalid Password";
  
   }
  else{
    document.getElementById("errmsg3").innerHTML = "";
document.getElementById("email").value="";
document.getElementById("password").value="";

  ActivityIndicator();

setTimeout(() => {
  axios({
    method: "POST",
    url: `${BASE_URL}/Authenticate/LOGIN`,
    // url:'https://localhost:44312/Api/Authenticate/LOGIN',
    data,
    headers: {
      "Content-Type": "application/json"
    }
  })
    .then((response) => {

      localStorage.setItem('ventureid',response.data.ventureid);    
 localStorage.setItem('username',response.data.userName);
 localStorage.setItem('email',response.data.email);
 let x = response.data.roleid =='00'?"Super Admin": response.data.roleid=='01' ? 'Admin' : response.data.role
 localStorage.setItem("RoleName",x);
 localStorage.setItem("Role",response.data.role);
 localStorage.setItem("RoleId",response.data.roleid);
 localStorage.setItem('usertoken', JSON.stringify(response.data.token));
 localStorage.setItem('UserId',response.data.id);

      // console.log("Response", response.data.ventureid)


      const body ={
  
        userId: localStorage.getItem('UserId')
      
       }
       console.log(body);
      
      
        axios({          
           method: "POST", 
           //url: `${BASE_URL}/Tc/EditSection`,      
           url: "https://localhost:44312/Api/Authenticate/GetVentureName",
           data:body,
           headers: {             
             'Content-Type': 'application/json' , 
             //'Authorization':bearer     
           }
         
         })
         .then((response) =>{
          console.log(response.data);
          setName(response.data)
      
           }) 

         
      if(response.data.status =="InActive"){

      
        toast.error("Failure...! InActivated User")
        document.getElementById("activity-indicator").style.display = "none";
       }
  
       else if(response.data.status == "UnAuthorized")
  
  
  
          {
  
             toast.error("Failure...! UnAuthorized")
             document.getElementById("activity-indicator").style.display = "none";
  
          }
              else if (response.data.ventureid == '00')
    {
        
       
    
        window.location.href="/#/SuperAdmdashboard"
        
}
        else if (response.data.ventureid.length == 2)
        {
            // alert('Super Admin')
            window.location.href=`${Hashslash}${response.data.ventureName}`
    }
//     else if (response.data.ventureid == '01')
//     {
//         // alert('Thatscool')
       
    
//         window.location.href="/#/Thats Cool"
        
// }
// else if (response.data.ventureid == '02')
// {
//     // alert('Paropakari')

//     // if (response.data.Active !='1'){

    
//     window.location.href="/#/Paropakari"}
// //     else{
// //       alert('Inactivated user!')
// //     }
// // }
// else if (response.data.ventureid == '03')
// {
//     // alert('Oat')
//     window.location.href="/#/OAT"
// }
// else if (response.data.ventureid == '04')
// {
//     // alert('Kdp foundation')
//     window.location.href="/#/Kdp Foundation"
// }
// else if (response.data.ventureid == '05')
// {
//     // alert('Kdp corp')
//     window.location.href="/#/Kdp Corp"
// }
// else if (response.data.ventureid == '06')
// {
//     // alert('Kdp tec')
//     window.location.href="/#/Kdp Tec"
// }

else if (response.data.ventureid.length >2){
  document.getElementById('dashboard-names').style.display = 'block'
  document.getElementById("activity-indicator").style.display = "none";

}
    else
    {
      toast.error("Try another");
      document.getElementById("activity-indicator").style.display = "none";
    }
    })
    .catch(error => {

      console.log(error);

      toast.error("Unauthorized user");
      document.getElementById("activity-indicator").style.display = "none";

      return false;

    })
  }, 3000);
  }}
  
  //validation//

function handlechange(){
  var email = document.getElementById("email").value;
  var psw = document.getElementById("password").value;

 if(!email ){
document.getElementById("errmsg").innerHTML = "Email Required";
document.getElementById("errmsg1").innerHTML = "";

 }
 else if(!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email)){
  document.getElementById("errmsg").innerHTML = "";
   document.getElementById("errmsg1").innerHTML = "Invalid email";
 
 }
 else {
  document.getElementById("errmsg").innerHTML = "";
   document.getElementById("errmsg1").innerHTML = "";
 }
 if(!psw){
   document.getElementById("errmsg2").innerHTML = "Password Required";
   document.getElementById("errmsg3").innerHTML = "";

 }
 else if(!/^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/.test(psw)){
    //document.getElementById("errmsg3").innerHTML = "Password must contain 8 character, atleast one UPPERCASE, one lowercase, one number & one special char";
  document.getElementById("errmsg2").innerHTML = "";
   document.getElementById("errmsg3").innerHTML = "Invalid Password";

 }
 else{
  document.getElementById("errmsg2").innerHTML = "";
   document.getElementById("errmsg3").innerHTML = "";

 }}

 function hide(){

  var x = document.getElementById("password");

  var eye = document.getElementById("eye");

  if(x.type === "password"){
 x.type = "text";
    eye.classList.remove("fa-eye-slash")
    eye.classList.add("fa-eye")
   
 }
  else{
    x.type = "password";
    eye.classList.remove("fa-eye")
    eye.classList.add("fa-eye-slash")

  }
 }
  return (

    <div className="container-fluid px-1 px-md-5 px-lg-1 px-xl-5 py-5 mx-auto">
      <div className="card card0 border-0">
        <div className="row d-flex">
          <div className="col-lg-6">
            <div className="card1 pb-5">
              <div className="row px-3 justify-content-center mt-4 mb-5 border-line">
                <img src="https://coincent.ai/images/login.png" className="image" alt='pic' />
              </div>
            </div>
          </div>

          <div className="col-lg-6">
            <div className="card2 card border-0 px-4 py-5" id='card2'>
              <div className="row mb-4 px-3">
               
                <div className='heading'>
                  <h2 className="mb-0 mr-4 mt-2">LOGIN</h2></div>
               </div>
             
             
               <span id="errmsg"></span>
               <span id="errmsg1"></span>
              <div className="row px-3">
                <input className="mb-4" type="text"   onKeyUp={handlechange} 
                id="email" name="email" placeholder="Email Address"/>
              </div>
             
              
              <span id="errmsg2"></span>
               <span id="errmsg3"></span>
             
              <div className="row px-3"> 
              <div className='eyeicon'><i class="fa fa-eye-slash" aria-hidden="true" onClick={hide} id="eye"></i></div>                
                <input type="password" name="password"
               onKeyUp={handlechange}  id="password" placeholder="Password"/>
              </div>

              <div className="row px-3 mb-4">
                <div className='fpsw'>
                  <nav><Link to="/Forgotpassword">Forgot password?</Link></nav>
                </div>
              </div>

              <div class="row mb-3 px-3">
                <button type="submit" className="btn btn-blue text-center" onClick={handleSubmit}>Login</button>

                <div className='TCpopfade' id='dashboard-names'>

<div  className="main-container">

<div className="Lredirect" >

    <h3 class="login-title" >DASHBOARD</h3>


<br></br>

<form style={{textAlign:"center",marginLeft:"-30px"}}>
<ul>
{name.map((e)=>

{
  return<li  id='dash-list'>
  <nav>
<label  id="LredirecList"> <Link to={`${Slash}${e.ventureName}`}  >{e.ventureName}</Link> </label>  
</nav>
</li>

 })}
</ul>
</form>

</div>

</div>
</div>
           {/* <div className="oat-pop-fade"  id='dashboard-names' tabindex="-1" role="dialog">
     <div className="modal-dialog" role="document">
      <div className="modal-content">
      <div className="modal-header text-center">
        <h4 className="modal-title w-100 font-weight-bold">DASHBOARD</h4>
        
         
      </div>

      <ul>
{name.map((e)=>
{
 
  return<li id='dash-list'>

  <nav>
<label  id="tc"> <Link to={`${Slash}${e.ventureName}`}>{e.ventureName}</Link> </label>   
</nav>
  
           </li> 
           }
           )} 
</ul>
      
     </div>
    </div>
</div> */}
      
           
                <ToastContainer
                  position="top-center"
                  autoClose={1000}
                  hideProgressBar={false}
                  newestOnTop={false}
                  closeOnClick
                  rtl={false}
                  pauseOnFocusLoss
                  draggable
                  pauseOnHover
                  theme="light" />
                  {/* <PulseLoader size={7}
 id='activity' style={{display:"none"}} />  */}
{/* <FadeLoader id='activity' 
        color={'black'}
      width={5}
        height={15}
        aria-label="Loading Spinner"
        data-testid="loader"
      /> */}
 
{/* <div id='activity' style={{display:"none"}}> */}
   
{/* <ActivityIndicator
    //  number={5}
     diameter={7}
    //borderWidth={1}
      duration={400}
    activeColor="black"
    // borderColor="white"
    //   // borderWidth={5}
    borderRadius="50%" 
  
/> */}

 


              </div>
              
    <div className='TCpopfade' id="activity-indicator">
      
         <FadeLoader id='activity' 
        color={'white'}
      width={5}
        height={15}
        aria-label="Loading Spinner"
        data-testid="loader"
      />
       
          </div>

            </div>
          </div>
        </div>

      </div>
    </div>

  );
}

